import { React, useEffect } from "react";
import { useLocation } from "react-router-dom";
import useIsMobile from "../hooks/useIsMobile";
import abrirWhatsApp from "../hooks/abrirWhatsapp";
import styles from "../styles/resultadoCalculo.module.css";
import usePageTracking from "../components/pageTracking";
import ReactPixel from "react-facebook-pixel";

const ResultadoCalculo = () => {
  const { state } = useLocation();
  const retornoApi = state?.retornoApi;
  const isMobile = useIsMobile();

  usePageTracking();

  useEffect(() => {
    ReactPixel.pageView(); // Dispara evento de pageview
    ReactPixel.track("ResultadoCalculo"); // Evento customizado, opcional

    if (typeof window.gtag === "function") {
      console.log("Evento do google");
      window.gtag("event", "conversion", {
        send_to: "AW-16733526562/H6acCNac1OQaEKK0las-",
      });
    }
  }, []);

  return (
    <div className="container-fluid tela-central text-center">
      <div className="text-center">
        <div className="logo-topo">
          <img className="mt-1" src="../img/iconwp.png" alt="" width="120px" />
        </div>
        <div className={`${styles.conteudo}`}>
          <div
            className="mt-5"
            style={isMobile ? {} : { paddingLeft: "10%", paddingRight: "10%" }}
          >
            <h1 style={{ fontWeight: "bold" }} className={`${styles.titulo} `}>
              Vamos lá!
            </h1>
            <br />
            <label className={`${styles.descricao} `}>
              Já temos um relatório prévio sobre o seu caso e, considerando as
              informações coletadas, verificamos uma potencial restituição de
              até
            </label>
            <label
              className={`${styles.titulo} mt-1`}
              style={{ fontWeight: "bold" }}
            >
              {Number(retornoApi.SALDO_REVISADO).toLocaleString("pt-br", {
                style: "currency",
                currency: "BRL",
              })}
            </label>
            <br />
            <br />
            <label className={`${styles.descricao}`}>
              Você pode olhar todos os detalhes no relatório enviado no seu
              e-mail ou solicitar uma consulta conosco.
            </label>
            <br />
            <br />
            <button
              className={
                isMobile
                  ? "btn btn-primary borda-botao"
                  : "btn btn-primary btn-lg borda-botao"
              }
              style={{ width: "400px" }}
              onClick={() => abrirWhatsApp(true)}
            >
              Quero falar com um especialista!
            </button>
            <br />
            <br />
            <label className={`${styles.obs} mb-3`}>
              Obs.: o resultado do cálculo é uma estimativa que não substitui
              uma análise aprofundada do caso concreto e das condições e
              peculiaridades do contrato em análise.
            </label>
          </div>
        </div>
      </div>

      {/* Elementos decorativos */}
      <div className="quadrado-preto" />
      <div className="quadrado-listrado" />
      <div className="quadrado-listrado-preto" />
    </div>
  );
};

export default ResultadoCalculo;
